export function mergeGameStateDelta(state, delta) {
  const next = { ...(state || {}) };
  for (const key of Object.keys(delta || {})) {
    if (key === 'board' && delta.board) {
      const baseBoard = next.board || {};
      const mergedBoard = { ...baseBoard, ...delta.board };
      if (delta.board.battlefields) {
        const bfs = Array.isArray(baseBoard.battlefields) ? [...baseBoard.battlefields] : [];
        for (const [idx, bfDelta] of Object.entries(delta.board.battlefields)) {
          const i = Number(idx);
          bfs[i] = bfs[i] ? { ...bfs[i], ...bfDelta } : bfDelta;
        }
        mergedBoard.battlefields = bfs;
      }
      next.board = mergedBoard;
    } else if ((key === 'human' || key === 'bot') && delta[key]) {
      const currentPlayer = next[key] || {};
      const playerDelta = delta[key] || {};
      next[key] = {
        ...currentPlayer,
        ...playerDelta,
        base: playerDelta.base
          ? { ...(currentPlayer.base || {}), ...playerDelta.base }
          : currentPlayer.base,
        resources: playerDelta.resources
          ? { ...(currentPlayer.resources || {}), ...playerDelta.resources }
          : currentPlayer.resources,
      };
    } else {
      next[key] = delta[key];
    }
  }
  return next;
}
